import React from 'react';

import Page from 'app/components/misc/BasePage';
import PageHead from 'app/components/misc/PageHead';
import SavedContent from 'app/pageContents/SavedContent';

const SavedPage = ({ savedCount }) => {
  return (
    <Page>
      <PageHead pageTitle="Saved Content - " />
      <SavedContent savedCount={savedCount} />
    </Page>
  );
};

export default SavedPage;
